import axios from "axios";

const baseURL = `${process.env.VUE_APP_BASE_DOMAIN}/v2`;

export default axios.create({
    baseURL,
    withCredentials: true,
});
